import React, { useState } from 'react'
import './EnquiryForm.css';
import notify from '../../utils/Notification';
import { createB2BAPI } from '../../api/Interceptor';
import { Button, Input } from '@mantine/core';

const EnquiryForm = ({ contactRef }) => {
    const [enquiry, setEnquiry] = useState({
        contractName: '',
        contractMobileNumber: '',
        companyName: '',
        businessType: '',
        thoughts: ''
    });
    const condition = !(
        enquiry?.contractName &&
        enquiry?.contractMobileNumber &&
        enquiry?.companyName &&
        enquiry?.businessType &&
        enquiry?.thoughts
    );
    const maxLength = 1000;
    const B2B_API = createB2BAPI();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEnquiry((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await B2B_API.post(`customerEnquiry/save`, { json: enquiry }).json();
            notify({
                id: 'enquiry_form',
                title: 'Success!',
                message: 'Inquiry submitted successfully',
                error: false,
                success: true,
            });
            setEnquiry({
                contractName: '',
                contractMobileNumber: '',
                companyName: '',
                businessType: '',
                thoughts: ''
            });
        } catch (error) {
            notify({
                id: 'enquiry_form',
                error: true,
                success: false,
                title: error?.message || 'Error submitting inquiry',
            });
        }
    };

    return (
        <div className='enquiry-form' ref={contactRef}>
            <div className="enquiry">
                <div className="bordered-title" data-aos='fade-up'>Contact Us <br />to Learn More</div>
                <form className="required" onSubmit={handleSubmit} data-aos='fade-right'>
                    <div>
                        <label className='label'>Contact Name <span className='requi-star'> *</span></label>
                        <Input
                            className="input-text"
                            type="text"
                            name="contractName"
                            value={enquiry.contractName}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label className='label'>Mobile Number <span className='requi-star'> *</span></label>
                        <Input
                            type="text"
                            className="input-text"
                            name="contractMobileNumber"
                            value={enquiry.contractMobileNumber}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label className='label'>Company Name <span className='requi-star'> *</span></label>
                        <Input
                            type="text"
                            className="input-text"
                            name="companyName"
                            value={enquiry.companyName}
                            onChange={handleChange}
                        />
                    </div>

                    <div style={{ lineHeight: '2rem' }}>
                        <label className="label">Business Type <span className='requi-star'> *</span></label>
                        {['fashion_brand', 'garment_dev_prod', 'fabric_sourcing_agency', 'fabric_retail', 'other'].map((type) => (
                            <div key={type} className="radio-item">
                                <Input
                                    type="radio"
                                    name="businessType"
                                    value={type}
                                    checked={enquiry.businessType === type}
                                    onChange={handleChange}
                                />
                                {type.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())}
                            </div>
                        ))}
                    </div>

                    <div>
                        <div>
                            <label className='label'>Tell us your thoughts! <span className='requi-star'> *</span></label>
                        </div>
                        <textarea
                            name="thoughts"
                            maxLength={maxLength}
                            style={{ height: "160px", width: "100%", marginTop: '0.5rem' }}
                            value={enquiry.thoughts}
                            onChange={handleChange}
                        />
                        <div className="text-right">
                            <span>{enquiry.thoughts.length} / {maxLength}</span>
                        </div>
                    </div>

                    <div className='submit-btn'>
                        <Button type="submit"
                            disabled={condition}
                            style={{ backgroundColor: '#8BC53F',borderRadius:"50px", color: 'white' }}
                            className="btnbtn-dark">Submit Enquiry</Button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default EnquiryForm;
